import React from 'react';
import Propagator from '../../Propagator';
import { Mutation } from 'react-apollo';
import gql from 'graphql-tag';

const DELETE_SESSION_MUTATION = gql`
	mutation($sessionID: ID!) {
		deleteSession(sessionID: $sessionID) {
			id
			name
			date
			owners {
				id
			}
		}
	}
`;

export default ({ children }) => (
	<Mutation mutation={DELETE_SESSION_MUTATION} refetchQueries={['adminQuery']}>
		{deleteSession => Propagator(children, deleteSession)}
	</Mutation>
);
